import { Epic, combineEpics } from 'redux-observable';
import { searchSchoolsUpdated, SearchSchoolsUpdated } from '../actions/SearchActions';
import { StoreState } from '../types';
import { observeChangesAllBuffered } from '../firebase';
import { map } from 'rxjs/operators';
import { destinationsUpdated, DestinationsUpdated } from '../actions/DestinationActions';
import { ActivityUpdated, activitiesUpdated } from '../actions/ActivityActions';
import { instructorProfilesUpdated, InstructorProfilesUpdated } from '../actions/SchoolJobsActions';

const searchDocumentsEpic: Epic<SearchSchoolsUpdated, SearchSchoolsUpdated, StoreState> =
    (action$, store$) =>
        observeChangesAllBuffered('search', 100).pipe(map(searchSchoolsUpdated));

const destinationDocumentsEpic: Epic<DestinationsUpdated, DestinationsUpdated, StoreState> =
    (action$, store$) =>
        observeChangesAllBuffered('destinations', 100).pipe(map(destinationsUpdated));

const activityDocumentsEpic: Epic<ActivityUpdated, ActivityUpdated, StoreState> =
    (action$, store$) =>
        observeChangesAllBuffered('activities', 100).pipe(map(activitiesUpdated));

const instructorProfileDocumentsEpic: Epic<InstructorProfilesUpdated, InstructorProfilesUpdated, StoreState> =
    (action$, store$) =>
        observeChangesAllBuffered('instructorProfiles', 100).pipe(map(instructorProfilesUpdated));

export default combineEpics(
    searchDocumentsEpic,
    destinationDocumentsEpic,
    activityDocumentsEpic,
    instructorProfileDocumentsEpic
);        